import React, { PropsWithChildren, useState } from 'react'
import { CustomSelectField, CustomSelectFieldProps } from '../CustomSelect/CustomSelectField'
import filterStyles from '../CustomSelect/customSelect.module.scss'

type FilterDropdownProps = {
    defaultSelectValue: string
} & CustomSelectFieldProps;

export const FilterDropdown: React.FC<PropsWithChildren<FilterDropdownProps>> = ({
  defaultSelectValue,
  options,
  onChange,
}) => {
  const [filterValue, setFilterValue] = useState<string | number>('')

  return (

    <div className={filterStyles.filterDropdownWrapper}>
      <h3 className={filterStyles.filterLabel}>Filter by </h3>
      <CustomSelectField
        label={defaultSelectValue}
        options={options}
        value={filterValue}
        isFilterIcon={true}
        onChange={(value: string | number) => {
          // @ts-ignore
          setFilterValue(value)
          onChange(value)
        }}
      />
    </div>
  )
}
